import Mapview from "../../../components/quality/punchlist/mapview/mapview";
import Quality from "../../../container/quality";
import Punchlist from "../../../container/quality/punchlist";
import PunchlistBlockDetail from "../../../container/quality/punchlist/mapview/blockdetail";
import LogsAndChecklists from "../../../container/quality/logs-and-checklists/logs-and-checklist/index"
import LogsAndChecklistsBlockDetails from "../../../container/quality/logs-and-checklists/logs-and-checklist/blockDetails"
import LockAndUnlock from "../../../container/quality/logs-and-checklists/lock-and-unlock/index"
import LockAndUnlockBlockDetails from "../../../container/quality/logs-and-checklists/lock-and-unlock/blockDetails"



const qualityRoute = [
  {
    path: "quality",
    element: <Quality />,
  },
  {
    path: "quality/qc-punchlist",
    element: <Punchlist />
  },
  {
    path: "quality/logs-and-checklists",
    element: <LogsAndChecklists />
  },
  {
    path: "quality/logs-and-checklists/:id",
    element: <LogsAndChecklistsBlockDetails />
  },
  {
    path: "quality/lock-and-unlock",
    element: <LockAndUnlock />
  },
  {
    path: "quality/lock-and-unlock/:id",
    element: <LockAndUnlockBlockDetails />
  },
  {
    path: "quality/qc-punchlist/mapview",
    element: <Mapview />
  },
  {
    path: "quality/qc-punchlist/mapview/:id",
    element: <PunchlistBlockDetail />
  }
];

export default qualityRoute;
